import type { ElementType, HTMLProps } from 'react'
import cn from 'classnames'
import styles from './Table.module.css'

interface TableElementProps extends Omit<HTMLProps<HTMLDivElement>, 'as'> {
  as?: ElementType
}

function Cell({ as: Component = 'div', className, ...props }: TableElementProps) {
  return <Component className={cn(styles.cell, className)} {...props} />
}

function Header({ className, ...props }: TableElementProps) {
  return <Cell className={cn(styles.header, className)} {...props} />
}

function Col({ as: Component = 'div', className, ...props }: TableElementProps) {
  return <Component className={cn(styles.col, className)} {...props} />
}

function HeaderColumn({ className, ...props }: TableElementProps) {
  return <Header className={cn(styles.headerColumn, className)} {...props} />
}

function TopLeftHeader({ className, ...props }: TableElementProps) {
  return <HeaderColumn className={cn(styles.topLeftHeader, className)} {...props} />
}

function Body({ as: Component = 'div', className, ...props }: TableElementProps) {
  return <Component className={cn(styles.body, className)} {...props} />
}

function Root({ as: Component = 'div', className, ...props }: TableElementProps) {
  return <Component className={cn(styles.root, className)} {...props} />
}

export { Body, Cell, Col, Header, HeaderColumn, Root, TopLeftHeader }
